import React from 'react';
import { ChartSetList } from '../../types';

interface SetlistListProps {
  collections: ChartSetList[];
  selectedCollectionId: string | null;
  onSelectCollection: (id: string) => void;
  onDeleteCollection: (id: string) => void;
  onCreateNew: () => void;
}

const SetlistList: React.FC<SetlistListProps> = ({
  collections,
  selectedCollectionId,
  onSelectCollection,
  onDeleteCollection,
  onCreateNew
}) => {
  return (
    <div className="w-full sm:w-1/4 border-b sm:border-b-0 sm:border-r border-gray-700 p-3 sm:p-4 overflow-y-auto max-h-[80vh] sm:max-h-full">
      <h3 className="text-lg font-semibold text-white mb-4">Your Setlists</h3>
      {collections.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-400 mb-4">No setlists yet</p>
          <button
            onClick={onCreateNew}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-500 text-white rounded-md font-semibold transition-colors"
          >
            Create Your First Setlist
          </button>
        </div>
      ) : (
        <div className="space-y-2">
          {collections.map(collection => (
            <div
              key={collection.id}
              onClick={() => onSelectCollection(collection.id)}
              className={`group p-3 rounded-lg cursor-pointer transition-all ${
                selectedCollectionId === collection.id
                  ? 'bg-gray-700 ring-2 ring-purple-500'
                  : 'bg-gray-750 hover:bg-gray-700'
              }`}
            >
              <div className="flex items-center gap-3">
                <div 
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: collection.color || '#8B5CF6' }}
                />
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-white truncate">{collection.name}</h4>
                  <p className="text-sm text-gray-400">{collection.chartTitles.length} charts</p>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteCollection(collection.id);
                  }}
                  className="p-1 text-gray-400 hover:text-red-400 transition-colors sm:opacity-0 sm:group-hover:opacity-100"
                  title="Delete Setlist"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
              {collection.description && (
                <p className="text-sm text-gray-400 mt-2 line-clamp-2">{collection.description}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SetlistList;
